import React, { memo } from 'react';
import { useSelector } from 'react-redux';

// These are regular React components we will write soon
import ElementForm from '../../content/ElementsPage/ElementForm';
import VariantGroupForm from '../../content/ElementsPage/VariantGroupForm';
import DeviceForm from '../Devices/DeviceForm';
import StreamItemForm from '../../content/StreamsPage/StreamItemForm';
import LocationForm from '../../content/LocationsPage/LocationForm';
import UserForm from '../User/UserForm';
import OrganisationForm from '../Organisation/OrganisationForm';

const FORM_COMPONENTS = {
  ELEMENT_FORM: ElementForm,
  VARIANT_GROUP_FORM: VariantGroupForm,
  MICAST_FORM: DeviceForm,
  LOCATION_FORM: LocationForm,
  STREAM_ITEM_FORM: StreamItemForm,
  USER_FORM: UserForm,
  ORGANISATION_FORM: OrganisationForm,
  /* other modals */
};

const RootSideForms = memo(() => {
  const { formType, formProps } = useSelector((state) => state.sideForms);
  if (!formType) {
    return null;
  }
  const SpecificForm = FORM_COMPONENTS[formType];
  return <SpecificForm {...formProps} />;
});

export default RootSideForms;
